'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
exports.default = generateAddressValidator;
var _customerUiFetchActions = require('@energysavvy/customer-ui-fetch-actions');
var _queryString = require('query-string');
var _queryString2 = _interopRequireDefault(_queryString);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function flattenQueryArgsAddress(queryArgs) {
  return _extends({}, queryArgs, {
    'filter[street_address_one]': [queryArgs['filter[street_address_one]'], queryArgs['filter[street_address_two]']].filter(Boolean).join(' ').trim(),
    'filter[street_address_two]': undefined
  });
}
function generateAddressValidator(_ref) {
  var fields = _ref.fields,
    networkErrorMessage = _ref.networkErrorMessage,
    defaultErrorMessage = _ref.defaultErrorMessage,
    addressErrorMessage = _ref.addressErrorMessage;
  return function (allAnswers) {
    var queryArgs = Object.entries(fields).reduce(function (accum, _ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      accum['filter[' + key + ']'] = allAnswers[value];
      return accum;
    }, {});
    queryArgs['fields[addresses]'] = 'NONE';

    // Validate the same format which we persist elsewhere (XP-920)
    // by combining address lines 1 & 2 onto line 1:
    var queryArgsWithFlattenedAddress = flattenQueryArgsAddress(queryArgs);
    if (!queryArgsWithFlattenedAddress['filter[postal_code]'] || !queryArgsWithFlattenedAddress['filter[street_address_one]']) {
      return Promise.resolve();
    }
    return (0, _customerUiFetchActions.fetchUrl)('/locations/addresses?' + _queryString2.default.stringify(queryArgsWithFlattenedAddress)).then(function (response) {
      if (response.data.length !== 1) {
        return Promise.reject(addressErrorMessage);
      }
      return Promise.resolve();
    }, function (error) {
      if (error.constructor === _customerUiFetchActions.errors.NetworkError) {
        return Promise.reject(networkErrorMessage);
      }
      return Promise.reject(defaultErrorMessage);
    });
  };
}